import BaseApi from "../../BaseApi";

export class API extends BaseApi {

  constructor({ hasLogo }) {
    super();
    this.site = scriptsData.siteUrl;
    this.defaultArgs = {
      posts_per_page: 99,
      filterByTaxonomy: false,
    };

    this.defaultArgs['hasLogo'] = hasLogo ?? false;
  }

  async loadContent(args) {

    const query = { ...args, ...this.defaultArgs };

    let queryString = new URLSearchParams(query).toString();
        queryString = queryString.length ? `?${queryString}` : '';

    const apiUrl = `${this.site}wp-json/wp/v2/get-ongs${queryString}`;
    const { data, totalPages } = await this.get(apiUrl);

    return { data, totalPages }
  }

}